export default "__VITE_ASSET__DxPSueDU__"